export default __webpack_public_path__ + "static/media/cluster1.3accca34.png";